module.exports = function () {

    let guardians = $('.guardians-payments');

    countForGuardians();

    $('.js-payment-part').on('change', function () {
        countForGuardians()
    });

    function countForGuardians()
    {
        guardians.each(function () {
            let $this = $(this);

            countFullPayment($this);
        });
    }

    function countFullPayment($this)
    {
        let $paymentPart = $this.find('.js-payment-part'),
            $summaryField = $this.find('#payment-summary');

        countSummary($paymentPart,  $summaryField);

        $paymentPart.on('change', function () {
            countSummary($paymentPart,  $summaryField);
        });
    }

    function countSummary($sourceFields, $destinationField)
    {
        let fullPayment = 0;

        $sourceFields.each(function (k, v) {
            let $this = $(v),
                val = parseFloat($this.val());

            if (!isNaN(val) && !$this.is(':disabled')) {
                fullPayment += val;
            }
        });

        $destinationField.html('£' + fullPayment);
    }
}();
